import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import Label from "../../components/FormComponents/Label";
import MultiSelectBox from "../../components/FormComponents/MultiSelectBox";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useAxiosContext } from "../../context/AxiosContext";
import { hasOwn } from "../../commonFunctions/arrayFunc";
import { toastError } from "../../utils/toastUtils";

const OwnerAssignment = ({
  ownerAssignment,
  setOwnerAssignment,
  style = { overflow: "auto", height: "calc(100vh - 72px)" },
  className = "p_3"
}) => {
  const [allGroups, setAllGroups] = useState([]);
  // const [allCommunityGroups, setAllCommunityGroups] = useState([]);
  const [allRoles, setAllRoles] = useState([]);

  const [selectedGroupsData, setSelectedGroupsData] = useState([]);
  const { axiosInstance, handleError } = useAxiosContext();
  const { orgId } = useParams();
  const [designationName, setDesignationName] = useState("");

  const fetchAllGroup = async () => {
    try {
      const { data } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      const selectedGroups = data.filter((group) => ownerAssignment.groups?.includes(group.id));
      setAllGroups(data);
      setSelectedGroupsData(selectedGroups);

      setOwnerAssignment({ ...ownerAssignment, groups: selectedGroups.map((grp) => grp.id) });
    } catch (error) {
      handleError(error);
    }
  };
  // const fetchCommunityUserGroups = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/community-user-groups`);
  //     setAllCommunityGroups(data);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  const fetchUserRoles = async () => {
    try {
      const { data } = await axiosInstance.get(`/user-service/role/org/${orgId}`);
      setAllRoles(data ?? []);
    } catch (error) {
      handleError(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setOwnerAssignment({ ...ownerAssignment, [name]: type === "checkbox" ? checked : value });
  };
  const handleSelectChange = (name, value) => {
    setOwnerAssignment({ ...ownerAssignment, [name]: value });
  };

  const callbackfunction = (data) => {
    const selectedDataOfId = data.map((group) => group.id);
    setOwnerAssignment({ ...ownerAssignment, groups: selectedDataOfId });
    setSelectedGroupsData([...data]);
  };

  // const communityCallbackfunction = (data) => {
  //   const selectedDataOfId = data.map((group) => group.id);
  //   setOwnerAssignment({ ...ownerAssignment, community_groups: selectedDataOfId });
  // };

  const rolesCallbackfunction = (data) => {
    setOwnerAssignment({ ...ownerAssignment, roles: data });
  };

  const addDesignation = () => {
    if (designationName.trim()?.length < 3) {
      toastError("Atleast three characters required");
      return;
    }
    const array = ownerAssignment.designations || [];
    setOwnerAssignment({ ...ownerAssignment, designations: [...array, designationName] });
    setDesignationName("");
  };

  const deleteDesignation = (index) => {
    const newDesignation = ownerAssignment.designations.filter((_, i) => i !== index);
    setOwnerAssignment({ ...ownerAssignment, designations: newDesignation });
  };

  useEffect(() => {
    fetchAllGroup();
    // fetchCommunityUserGroups();
    fetchUserRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let array = [];
  if (ownerAssignment["can_reassign"]) {
    array = ["can_reassign", "copy_parent_rule", "multiselect"];
  } else {
    array = ["multiselect", "allow_next_activity_assignment"];
  }

  const autoAssignOptions = [
    { id: "none", name: "None" },
    { id: "random", name: "Random" }
  ];

  const typeOptions = [
    { id: "anyone", name: "Anyone" },
    { id: "group", name: "Group" },
    // { id: "community_group", name: "Community Group" },
    { id: "designation", name: "Designation" },
    { id: "group-designation", name: "Group and Designation" },
    { id: "uid", name: "UID" },
    { id: "system", name: "System" },
    // { id: "roles", name: "Roles" },
    // { id: "role_positions", name: "Role Positions" },
    { id: "roles_or_groups", name: "Roles or Groups" },
    { id: "role_positions_or_groups", name: "Role Positions or Groups" }
  ];
  return (
    <div className={`flex_column gap_3 ${className}`} style={style}>
      <MultiSelectBox
        options={allRoles}
        selectedData={ownerAssignment.roles || []}
        onChange={rolesCallbackfunction}
        label="Allowed Roles"
      />
      <MultiSelectBox
        options={allGroups}
        selectedData={selectedGroupsData}
        onChange={callbackfunction}
        label="Allowed groups"
      />
      {/* <MultiSelectBox
        options={allCommunityGroups}
        selectedData={ownerAssignment.community_groups || []}
        onChange={communityCallbackfunction}
        label="Allowed Community Groups"
      /> */}

      <div className="flex_column gap_1">
        <Label>Allowed Designation</Label>
        <div className="flex_row align_center gap_3">
          <Input type="text" value={designationName} onChange={(e) => setDesignationName(e.target.value)} />
          <Button variant="secondary" onClick={addDesignation}>
            Add
          </Button>
        </div>
      </div>

      {ownerAssignment?.designations?.length > 0 && (
        <div className="selected_chip_container">
          {ownerAssignment.designations?.map((designations, index) => (
            <div className="selected_chip_items" key={designations}>
              {designations}{" "}
              <MaterialIcon name="close" onClick={() => deleteDesignation(index)} style={{ fontSize: "16px" }} />
            </div>
          ))}
        </div>
      )}

      {hasOwn(ownerAssignment, "auto_assign_strategy") && (
        <div className="builder_form">
          <SingleSelectBox
            selectedData={ownerAssignment.auto_assign}
            options={autoAssignOptions}
            onChange={(obj) => handleSelectChange("auto_assign", obj.id)}
            placeholder="Select strategy"
            label="Auto assign strategy"
          />
        </div>
      )}
      <div className="builder_form">
        <SingleSelectBox
          selectedData={ownerAssignment.type}
          options={typeOptions}
          onChange={(obj) => handleSelectChange("type", obj.id)}
          placeholder="Select type"
          label="Owner can be ?"
        />
      </div>
      {array.map((check) => (
        <div className="builder_checkbox_outer" key={check}>
          <Input
            label={check.split("_").join(" ") + ""}
            type="checkbox"
            checked={ownerAssignment[check]}
            name={check}
            onChange={handleInputChange}
          />
        </div>
      ))}
    </div>
  );
};

export default OwnerAssignment;
